export {default as dispatch} from "./dispatch.js";



//////////////////
// WEBPACK FOOTER
// ./~/d3-dispatch/src/index.js
// module id = ./node_modules/d3-dispatch/src/index.js
// module chunks = 54